import { Component, OnInit } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { MarketingService } from '../../../shared/_services/marketing.service';
import { LoyaltyService } from '../../../shared/_services/loyalty.service';
import { StatusModalComponent } from '../status-modal/status-modal.component';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ValidationService } from '../../../shared/_services/validation.service';
import { UtilService } from '../../../shared/_services/util.service';

@Component({
  selector: 'app-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: ['./catalog.component.scss']
})
export class CatalogComponent implements OnInit {
  levelsError: boolean;
  isProgramTypeSelected: boolean;
  successMsg: string;
  selectedLevels = [];
  selectedProgramType: any;
  loyaltyLevels: any[];
  loyaltyProgramTypes: any[];
  errorDetails: string;
  confirmModal: BsModalRef;
  bsConfig: Partial<BsDatepickerConfig> = { containerClass: 'theme-orange' };
  minStartDate = new Date();
  minEndDate = new Date();
  bsValue: Date;
  catalog: FormGroup;
  catalogId: string;
  title: string;
  list: any[];
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private utilService: UtilService,
    private marketingService: MarketingService,
    private loyaltyService: LoyaltyService,
    private validationService: ValidationService,
    private router: Router
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe).subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "catalog-modal") {
              this.bsModalRef.hide();
            }
          }
        }
      });
  }

  confirmModalWindow() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'catalog-modal',
      title: 'Cancel',
      message: `Are you sure you want cancel?`,
      action1: `Yes`,
      action2: 'No',
      action: '',
      style: 'active'
    }
  }

  addLoyalty(data) {
    let formArray = this.catalog.get('loyaltyIds') as FormArray;
    formArray.push(new FormControl(data));
  }

  toggleSelection(isChecked:boolean, level) {
    let formArray = this.catalog.controls['loyaltyIds'] as FormArray;
    
      if(isChecked) {
        formArray.push(new FormControl(level));
        this.selectedLevels.push(parseInt(level.id));
      } else {
        let index = formArray.controls.findIndex(x => x.value.id == level.id);
        let idx = this.selectedLevels.indexOf(parseInt(level.id));
        if(index > -1 && idx > -1) {
          formArray.removeAt(index); 
          this.selectedLevels.splice(idx, 1);
        }
      }
      this.checkError();
      console.log(formArray.value);
      console.log(this.selectedLevels);
  }

  toggleSelectionForProgramType(isChecked: boolean, programType: any) {
    if (isChecked) {
      this.selectedProgramType = programType.loyaltyProgramTypeId;
    } else {
      this.selectedProgramType = null;
    }
  
    if (this.selectedProgramType) {
      this.getLoyaltyLevels();
    } else {
      this.loyaltyLevels = [];
    }
  }
  
  checkError() {
    this.errorDetails = '';
    this.levelsError = false;
    let formArray = this.catalog.get('loyaltyIds') as FormArray;
    let empArray = formArray.value.length ? formArray.value[0].isEmployee : null;
    formArray.value.forEach(level => {
      if(level.isEmployee != empArray) {
        this.levelsError = true;
      }
    });
  }

  getLoyaltyLevels() {
    this.marketingService.getLoyaltyLevels(this.selectedProgramType).subscribe(res => {
      if (res.error == 0) {
        this.loyaltyLevels = res.responseObj;
        //this.selectedLevels.push(res.responseObj[0]);
      } else {
        this.errorDetails = res.message;
      }
    }, err => {
      console.log('Error in loyalty level :', err);
    })
  }

  getLoyaltyProgramTypes() {
    this.loyaltyService.getProgramTypes().subscribe(res => {
      if (res.error == 0) {
        this.loyaltyProgramTypes = res.responseObj;
      } else {
        this.errorDetails = res.message;
      }
    }, err => {
      console.log('Error in loyalty program types :', err);
    })
  }

  getCatalogInfo(id) {
    this.marketingService.getCatalogById(id).subscribe(res => {
      if (res.error == 0) {
        this.catalog.patchValue(res.responseObj);
        if(res.responseObj && res.responseObj.loyaltyIds && res.responseObj.loyaltyIds.length) {
          res.responseObj.loyaltyIds.forEach(level => {
            this.addLevel(level);
          });
        }
        // this.initForm(res.responseObj);
        // this.selectedLevels = res.responseObj.loyaltyIds.map(level => {
        //   return parseInt(level.id);
        // });

      }
    });
    // this.catalog.patchValue({
    //   catalogName: 'catalog1',
    //   loyaltyIds: [1],
    //   startDate: new Date(),
    //   endDate: new Date()
    // })
  }


  addCatalog(data) {
    this.errorDetails = "";
    this.successMsg = "";
    // let filtereddLevels = [];
    data.value.startDate = data.value.startDate ? this.utilService.parseDateStr(data.value.startDate) : null;
    data.value.endDate = data.value.endDate ? this.utilService.parseDateStr(data.value.endDate) : null;
    let catalogData = data.value;
    catalogData.catalogId = this.catalogId;
    // this.selectedLevels.forEach(slt => {
    //   this.loyaltyLevels.forEach(level => {
    //     if (level.loyaltyId == slt) {
    //       filtereddLevels.push(level)
    //     }
    //   })
    // })
    // catalogData.loyaltyIds = filtereddLevels;
    //this.catalog.patchValue({loyaltyIds: this.selectedLevels});
    this.marketingService.addCatalog(this.utilService.trimObj(catalogData), this.catalogId ? false : true).subscribe(res => {
      if (res.error == 0) {
        this.successMsg = 'Catalog saved successfully';
        setTimeout(() => {
          this.bsModalRef.hide();
          this.successMsg = '';
          this.bsModalRef = null;
        }, 500)
      } else {
        this.errorDetails = res.message;
      }
    }, err => {
      console.error(err.message);
      this.errorDetails = err.message;
    })
    console.log('====== catalog data =====', data.value);
  }

  addLevel(level) {
    let formArray = this.catalog.controls['loyaltyIds'] as FormArray;
    formArray.push(new FormControl(level));
    this.selectedLevels.push(parseInt(level.id));
  }

  initForm(data?) {
    let loyaltyIds = this.fb.array([], this.validationService.minLengthArray(1));
    this.catalog = this.fb.group({
      catalogName: [data? data.catalogName : '', [Validators.maxLength(60), Validators.required, this.validationService.noWhitespaceValidator]],
      loyaltyIds: loyaltyIds,
      startDate: [data && data.startDate ? new Date(data.startDate) : ''],
      endDate: [data && data.endDate ? new Date(data.endDate) : '']
    }, {validator: this.validationService.dateLessThan('startDate', 'endDate')})

    if(data && data.loyaltyIds && data.loyaltyIds.length) {
      data.loyaltyIds.forEach(level => {
        this.addLevel(level);
      });
      this.getLoyaltyProgramTypes();
      this.selectedProgramType = this.loyaltyProgramTypes.find(programType => programType.loyaltyProgramTypeId === data.loyaltyIds[0].loyaltyProgramTypeId);

    }

  }

  ngOnInit() {
    this.initForm(null);
    this.getLoyaltyProgramTypes();
    // let loyaltyIds = this.fb.array([], this.validationService.minLengthArray(1));
    // this.catalog = this.fb.group({
    //   catalogName: ['', [Validators.maxLength(60), Validators.required, this.validationService.noWhitespaceValidator]],
    //   loyaltyIds: loyaltyIds,
    //   startDate: [''],
    //   endDate: ['']
    // }, {validator: this.validationService.dateLessThan('startDate', 'endDate')})

    this.bsValue = new Date();
    setTimeout(() => {
      console.log('content value', this.catalogId);
      if (this.catalogId) {
        this.getCatalogInfo(this.catalogId);
      }
    }, 200);
    // this.catalog.get('startDate').valueChanges
    // .subscribe(value => { 
    //   this.minEndDate = new Date(value);
    // })
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


}



// WEBPACK FOOTER //
// ./src/app/components/modals/catalog/catalog.component.ts